 <h2 mat-dialog-title class="dialog-header d-flex align-items-center justify-content-between">
    <span class="title">{{ "exitWindow.txtTitle" | translate }}</span>
    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="#1f1f1f" (click)="clickIconClose($event)">
        <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z"/>
    </svg>
 </h2>
 <mat-dialog-content style="text-align: center;">
     <div class="block-icon d-flex align-items-center justify-content-center">
        <svg xmlns="http://www.w3.org/2000/svg" height="98px" viewBox="0 -960 960 960" width="98px" fill="#d0d0d0">
            <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z"/>
        </svg>
     </div>
     <div class="block-name">{{ "exitWindow.txtName" | translate }}</div>
     <div class="block-descriptions" innerHtml="{{ 'exitWindow.txtDescription' | translate }}"></div>

 </mat-dialog-content>
 <mat-dialog-actions align="center">
     <div class="btns-groups"> 
         <button class="btn-accept" (click)="onNoClick(true)">
             <span>{{ 'buttons.txtYes' | translate }}</span>
         </button>

         <button class="btn-cancel" (click)="onNoClick()" >
             <span>{{ 'buttons.txtNo' | translate }}</span>
         </button> 
     </div>       
   </mat-dialog-actions>
